import type { OrganizationRepository } from '@/core/organization'
import type { UseCase } from '@/core/shared'

export const getBillingInfo: UseCase<OrganizationRepository, 'getBillingInfo'> = repository => {
  return async (groupUid) => {
    return await repository.getBillingInfo(groupUid)
  }
}
